module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av261-410c1f5d1ffd042d8cd0081ad940b114.jpg";